import { BaseStore } from "../extends/base-store";
import { ImasterContent } from "../interfaces/imaster-content";

export class CertificadoStore extends BaseStore {
  objValores: Array<ImasterContent> = [];
  /**
   * @author Jose Wilson Mulato
   * @description Obtener valores por defecto a donar
   */
  protected async GetService() {
    this.objValores = [{ descParametro: 'Sí', consParametro: 'S', valor: 'S' }, { descParametro: 'No', consParametro: 'N', valor: 'N' }];
    // let elements: ImasterContent[] = await this.academicLevel.GetAcademicLevel();
    this.objValores.forEach(x =>
      this.Data.push({ Label: x.descParametro, Value: x.consParametro })
    );
    return;
  }
}



// WEBPACK FOOTER //
// ./src/app/store/certificado-donacion-store.ts